/* eslint-disable */

import {
  DEFAULT_FILTERS_CONFIGURATION,
} from 'shared-constants/src/filters';
import includes from '../includes';
import formatLocalCurrency from '../formatLocalCurrency';
import integerWithThousandSeparator from '../integerWithThousandSeparator';
import { filterSectionNames } from '../helpersMyCasa/constants';
import { getFilterData } from '../helpersMyCasa';

const createTXTLabelSentence = (section, activeFilters) => {
  const filterValues = activeFilters;
  const getFirstValidValue = (types, apx) => types
    .filter((type) => filterValues[`${type}${apx}`])
    .map((type) => filterValues[`${type}${apx}`])[0];

  const labelFrom = 'da';
  const labelTo = 'a';

  let result;

  const createPriceDescr = () => {
    let descr = '';
    if (filterValues.mqpriceMax || filterValues.mqpriceMin) {
      descr = ' al m²';
    } else if (filterValues.paymentMax || filterValues.paymentMin) {
      descr = ' al mese';
    }
    return descr;
  };

  switch (section) {
    case 'channel':
    case 'category':
    case 'propertyTypes':
      // already created
      return null;
    
    case 'mqprice':
    case 'payment':
    case 'price': {
      const priceTypes = getFilterData('priceType').values.map(
        (type) => type.value,
      );
      const from = getFirstValidValue(priceTypes, 'Min');
      const to = getFirstValidValue(priceTypes, 'Max');
      const renderCurr = (curr, pfx = '', withCurrency) => `${pfx} ${formatLocalCurrency(curr, 'it', { currencyPos: true, withCurrency })}`;
      const typePrice = createPriceDescr(from, to);
      const tr = filterValues.notrattris ? '(escl. Trattat. riserv.)' : null;
      const isFromOrTo = !!(from || to);
      const isFromAndTo = isFromOrTo && from && to;
      result = ('');

      if (isFromAndTo) {
        result = `${renderCurr(from, labelFrom, false)} ${renderCurr(to, labelTo, true)}${typePrice}${tr ? `${' '}${tr}` : ''}`;
      } else if (from) {
        result = `${renderCurr(from, labelFrom, true)}${typePrice}${tr ? `${' '}${tr}` : ''}`;
      } else if (to) {
        result = `fino a ${renderCurr(to, '', true)}${typePrice}${tr ? `${' '}${tr}` : ''}`;
      } else if (tr) {
        result = `Prezzo ${tr}`;
      }
      break;
    }
    case 'mq': {
      let from = filterValues.mqMin;
      let to = filterValues.mqMax;
      try {
        from = from ? integerWithThousandSeparator(parseInt(filterValues.mqMin, 10)) : null;
        to = to ? integerWithThousandSeparator(parseInt(filterValues.mqMax, 10)) : null;
      } catch (error) {
        console.log('createLabelSentence', error);
      }

      const isFromOrTo = !!(from || to);
      const isFromAndTo = isFromOrTo && from && to;
      result = ('');
      if (isFromAndTo) {
        result = `da ${from} a ${to} m²`;
      } else if (from) {
        result = `da ${from} m²`;
      } else if (to) {
        result = `fino a ${to} m²`;
      }
      break;
    }
    case 'rooms': {
      const { numRoomsMin, numRoomsMax } = filterValues;
      const numFrom = numRoomsMin && parseFloat(numRoomsMin);
      const numTo = numRoomsMax && parseFloat(numRoomsMax);
      let from = numFrom;
      let to = numTo;
      try {
        from = from ? integerWithThousandSeparator(parseInt(from, 10)) : null;
        to = to ? integerWithThousandSeparator(parseInt(to, 10)) : null;
      } catch (error) {
        console.log('createLabelSentence', error);
      }
      const sub = 'locale';
      const subs = 'locali';
      const isFromOrTo = !!(numFrom || numTo);
      const isFromAndTo = isFromOrTo && numFrom && numTo;
      result = ('');
      if (isFromAndTo) {
        result = `da ${from} a ${to} ${subs}`;
      } else if (numFrom) {
        result = `con almeno ${from} ${from > 1 ? subs : sub}`;
      } else if (numTo) {
        result = `fino a ${to} ${to > 1 ? subs : sub}`;
      }

      if (numFrom && numTo && numFrom === numTo) {
        if (numTo === 1) {
          result = 'solo monolocali';
        } else if (numTo === 2) {
          result = 'solo bilocali';
        } else if (numTo === 3) {
          result = 'solo trilocali';
        } else if (numTo === 4) {
          result = 'solo quadrilocali';
        } else {
          result = `solo ${to} ${subs}`;
        }
      }

      break;
    }
    case 'numBaths': {
      const value = filterValues.numBaths;
      const label = value > 1 ? 'bagni' : 'bagno';
      result = !!value && `con almeno ${`${value} ${label}`}`;
      break;
    }
    case 'numParkingSpaces': {
      const value = filterValues.numParkingSpaces;
      const label = value > 1 ? 'box / posti auto' : 'box / posto auto';
      result = !!value && `con almeno ${`${value} ${label}`}`;
      break;
    }
    case 'level': {
      const value = filterValues.level;
      const getStrValue = (val) => {
        switch (val) {
          case 'piano terra':
            return 'al piano terra';
          case 'intermedio':
            return 'a un piano intermedio';
          case 'ultimo':
            return 'all\'ultimo piano';
          default:
            return '';
        }
      };
      const strVal = getStrValue(value);
      result = !!value
        && (strVal || `dal ${value}° piano in su`);
      break;
    }
    case 'lift': {
      const value = filterValues.lift;
      let subValue;

      if (value === true || value === 'true') {
        subValue = 'con ascensore';
      } else if (value === false || value === 'false') {
        subValue = 'senza ascensore';
      } else if (!Number.isNaN(value)) {
        subValue = `con ascensore se piano oltre ${value}°`;
      }

      result = !!subValue && subValue;
      break;
    }
    case 'heatingType': {
      const value = filterValues.heatingType || [];
      const getStrValue = (val) => {
        const labelAut = 'autonomo';
        const labelCent = 'centralizzato';
        const inclAut = includes(val, labelAut);
        const inclCent = includes(val, labelCent);
        let res = '';

        if (inclAut && inclCent) {
          res = 'riscaldamento';
        } else if (inclAut) {
          res = 'riscaldamento autonomo';
        } else if (inclCent) {
          res = 'riscaldamento centralizzato';
        }

        return res;
      };
      result = value.length && `con ${getStrValue(value)}`;
      break;
    }
    case 'garden': {
      const value = filterValues.garden || [];
      const getStrValue = (val) => {
        const label1 = 'comune';
        const label2 = 'privato';
        const incl1 = includes(val, label1);
        const incl2 = includes(val, label2);
        let res = '';

        if (incl1 && incl2) {
          res = 'giardino';
        } else if (incl1) {
          res = 'giardino comune';
        } else if (incl2) {
          res = 'giardino privato';
        }

        return res;
      };
      result = value.length && `con ${getStrValue(value)}`;
      break;
    }

    case 'balconyAndTerrace': {
      const value = filterValues.balconyAndTerrace || [];
      const isTerrace = value.indexOf('terrazzo') > -1;
      const isBalcony = value.indexOf('balcone') > -1;
      const getStrValue = () => {
        let res = '';

        if (isBalcony && isTerrace) {
          res = 'balcone o terrazzo';
        } else if (isBalcony) {
          res = 'balcone';
        } else if (isTerrace) {
          res = 'terrazzo';
        }

        return res;
      };
      result = (isBalcony || isTerrace) && `con ${getStrValue()}`;
      break;
    }

    case 'energyClass': {
      const value = filterValues.energyClass;
      result = !!value && `con classe energetica almeno ${value}`;
      break;
    }
    case 'buildingCondition': {
      const value = filterValues.buildingCondition || [];
      const values = [];
      let subValue;

      if (includes(value, 'nuovo-ristrutturato')) {
        values.push('in ottime condizioni o ristrutturato');
      }
      if (includes(value, 'abitabile')) {
        values.push('in buono stato');
      }
      if (includes(value, 'da-ristrutturare')) {
        values.push('da ristrutturare');
      }

      if (values.length) {
        const valuesTxt = values.reduce((prev, curr) => `${prev},  ${curr}`);
        subValue = `${valuesTxt}`;
      }

      result = subValue;
      break;
    }
    case 'buildingYear': {
      const from = filterValues.buildingYearMin;
      const to = filterValues.buildingYearMax;
      const isFromOrTo = !!(from || to);

      result = ('');
      if (isFromOrTo) {
        let phrase = '';
        if (from && to) {
          phrase = `tra il ${from} e il ${to}`;
        } else if (from) {
          phrase = `a partire dal ${from}`;
        } else if (to) {
          phrase = `entro il ${to}`;
        }
        result = `costruita ${phrase}`;
      }
      break;
    }
    case 'availability': {
      let value;

      switch (filterValues.availability) {
        case 'occupato':
          value = 'occupata al rogito';
          break;
        case 'libero':
          value = 'libera al rogito';
          break;
        case 'nuda-proprieta':
          value = 'in nuda proprietà';
          break;
        case 'nuda proprieta':
          value = 'in nuda proprietà';
          break;
        case 'affittato':
          value = 'affittata al rogito';
          break;
        default:
          break;
      }

      result = !!value && value;
      break;
    }

    case 'sellerType': {
      const sellers = filterValues.sellerType || [];
      const sellersTxt = Array.isArray(filterValues.sellerType) ? sellers.reduce((prev, curr) => `${prev}, ${curr}`) : filterValues.sellerType;      
      result = sellers.length
        ? `da ${sellersTxt}`
        : null;
      break;
    }

    case 'photo':
      {
        const { photo } = filterValues;
        if (photo) {
          result = 'solo annunci con foto';
        }
      }
      break;

    case 'furniture': {
      const { furniture } = filterValues;
      const value = furniture || [];
      const values = {
        none: 'non arredato',
        partially: 'parzialmente arredato',
        full: 'arredato',
      };
      if (value.length === 3) {
        result = 'non arredato o parzialmente arredato o arredato';
      } else if (value.length === 2) {
        if (!includes(value, 'none')) {
          result = 'arredato o parzialmente arredato';
        } else if (includes(value, 'partially')) {
          result = 'non arredato o parzialmente arredato';
        } else {
          result = 'non arredato o arredato';
        }
      } else if (value.length) {
        result = values[value[0]];
      } else {
        result = filterSectionNames[section];
      }
      break;
    }

    case 'air_conditioned': {
      const { air_conditioned: airConditioned } = filterValues;
      if (airConditioned) {
        result = `solo con ${filterSectionNames[section]?.toLowerCase()}`;
      }
      break;
    }

    case 'is_lux': {
      const { is_lux: isLux } = filterValues;
      if (isLux) {
        result = `solo ${filterSectionNames[section]?.toLowerCase()}`;
      }
      break;
    }

    case 'publication_date': {
      const { publication_date: publicationDate } = filterValues;
      const values = {
        '2d': 'ultime 48h',
        '7d': 'ultima settimana',
        '30d': 'ultimo mese',
      };

      const articles = {
        '2d': 'pubblicato nelle ',
        '7d': 'pubblicato nell\'',
        '30d': 'pubblicato nell\'',
      };
      if (publicationDate) {
        result = `${articles[publicationDate]}${values[publicationDate]}`;
      }
      break;
    }
    case 'has_swimming_pool':
      {
        const { has_swimming_pool: hasSwimmingPool } = filterValues;
        if (hasSwimmingPool) {
          result = `solo con ${filterSectionNames[section]?.toLowerCase()}`;
        }
      }
      break;

    case 'has_reception':
      {
        const { has_reception: hasReception } = filterValues;
        if (hasReception) {
          result = `solo con ${filterSectionNames[section]?.toLowerCase()}`;
        }
      }
      break;
    case 'has_virtual_tour':
      {
        const { has_virtual_tour: hasVirtualTour } = filterValues;
        if (hasVirtualTour) {
          result = `solo con ${filterSectionNames[section]?.toLowerCase()}`;
        }
      }
      break;

    case 'exclude_auction':
      {
        const { exclude_auction: excludeAuction } = filterValues;
        if (excludeAuction) {
          result = `escludi ${filterSectionNames[section]?.toLowerCase()}`;
        }
      }
      break;

    case 'is_auction':
      {
        const { is_auction: isAuction } = filterValues;
        if (isAuction) {
          result = 'solo aste';
        } else if (isAuction === false) {
          result = 'escludi aste';
        }
      }
      break;

    case 'only_auction':
      {
        const { only_auction: onlyAuction } = filterValues;
        if (onlyAuction) {
          result = 'solo immobili all\'asta';
        }
      }
      break;

    case 'exclude_under_construction':
      {
        const { exclude_under_construction: excludeUnderConstruction } = filterValues;
        if (excludeUnderConstruction) {
          result = `escludi ${filterSectionNames[section].toLowerCase()}`;
        }
      }
      break;
    case 'exclude_private_negotiation':
      {
        const { exclude_private_negotiation: excludePrivateNegotiation } = filterValues;
        if (excludePrivateNegotiation) {
          // TODO: remove comment when also filters are translated
          result = `escludi trattative riservate`;
          // result = 'solo con prezzo visibile';
        }
      }
      break;
    
      case 'only_private_negotiation':
        {
          const { only_private_negotiation: onlyPrivateNegotiation } = filterValues;
          if (onlyPrivateNegotiation) {
            // TODO: remove comment when also filters are translated
            // result = `solo con ${filterSectionNames[section]}`;
            result = 'solo con trattativa riservata';
          }
        }
        break;
      
      case 'includes_property_ownership':
      {
        const { includes_property_ownership } = filterValues;
        if (includes_property_ownership) {
          result = `solo ${includes_property_ownership === 'true' ? 'con' : 'senza'} mura`;
        }
      }
      break;

    case 'commercial_building_location':
      {
        const { commercial_building_location } = filterValues;
        if (commercial_building_location) {
          const valuesArr = !Array.isArray(commercial_building_location)
            ? commercial_building_location.split(',')
            : commercial_building_location;
          const displayValues = valuesArr.map((val) => DEFAULT_FILTERS_CONFIGURATION.commercial_building_location.values.filter((el) => el.value === val)[0].display);
          const last = displayValues.pop();
          result = `solo ${displayValues.join(', ')}${displayValues.length ? ' e ' : ''} ${last}`;
        }
      }
      break;

    default:
      break;
  }

  return result || filterSectionNames[section];
};

export default createTXTLabelSentence;
